export default __webpack_public_path__ + "static/media/msrm.76f0306b.svg";